import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="privacy-policy-content" style={{ padding: '40px 20px', lineHeight: '1.8' }}>
              <h1 style={{ 
                fontSize: '2.5rem', 
                fontWeight: 'bold', 
                marginBottom: '30px', 
                textAlign: 'center',
                color: '#2c3e50'
              }}>
                Privacy Policy
              </h1>
              
              <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                <p style={{ marginBottom: '20px', fontSize: '1.1rem' }}>
                  
                </p>

                <p style={{ marginBottom: '30px', fontSize: '1.1rem' }}>
                  Welcome to Central Business Hub ("Company", "we", "our", or "us"). Your privacy is important to us, 
                  and we are committed to protecting the personal information you share with us through our website: 
                  <a href="https://centralbusinesshub.in" style={{ color: '#C28562', textDecoration: 'none' }}> https://centralbusinesshub.in</a> ("Site").
                </p>

                <p style={{ marginBottom: '30px', fontSize: '1.1rem' }}>
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
                </p>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    1. Information We Collect
                  </h2>
                  <p style={{ marginBottom: '15px' }}>We may collect the following types of personal information:</p>
                  <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>
                      <strong>Personal Information:</strong> Name, email address, phone number, business name, GST number, and other contact or identity details.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      <strong>Usage Data:</strong> IP address, browser type, device information, pages visited, time spent on pages, and referring website.
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      <strong>Communication Data:</strong> Messages sent through contact forms, inquiries, or any customer support interaction.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    2. How We Use Your Information
                  </h2>
                  <p style={{ marginBottom: '15px' }}>We may use your data to:</p>
                  <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>Provide and manage our services</li>
                    <li style={{ marginBottom: '8px' }}>Respond to inquiries and customer support requests</li>
                    <li style={{ marginBottom: '8px' }}>Improve our website and service offerings</li>
                    <li style={{ marginBottom: '8px' }}>Send newsletters or promotional communications (only if you opt-in)</li>
                    <li style={{ marginBottom: '8px' }}>Comply with legal obligations</li>
                  </ul>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    3. Sharing Your Information
                  </h2>
                  <p style={{ marginBottom: '15px' }}>We do not sell or rent your personal information. However, we may share it with:</p>
                  <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '10px' }}>
                      Service providers and partners who help us operate the website or provide our services (e.g., hosting providers, CRM tools).
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                      Legal or regulatory authorities, when required by law or to protect our legal rights.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    4. Cookies and Tracking Technologies
                  </h2>
                  <p style={{ marginBottom: '15px' }}>Our website may use cookies and other tracking technologies to:</p>
                  <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>Analyze traffic and usage patterns</li>
                    <li style={{ marginBottom: '8px' }}>Enhance user experience</li>
                    <li style={{ marginBottom: '8px' }}>Remember preferences</li>
                  </ul>
                  <p style={{ marginBottom: '20px' }}>You can manage cookie preferences via your browser settings.</p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    5. Data Security
                  </h2>
                  <p style={{ marginBottom: '20px' }}>
                    We implement industry-standard security measures to protect your data. However, no method of transmission 
                    over the Internet is 100% secure. We cannot guarantee absolute security.
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    6. Your Rights
                  </h2>
                  <p style={{ marginBottom: '15px' }}>Depending on your location, you may have the right to:</p>
                  <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>Access, update, or delete your personal data</li>
                    <li style={{ marginBottom: '8px' }}>Withdraw consent for marketing communications</li>
                    <li style={{ marginBottom: '8px' }}>Request data portability</li>
                  </ul>
                  <p style={{ marginBottom: '20px' }}>
                    To exercise your rights, contact us at 
                    <a href="mailto:info@centralbusinesshub.in" style={{ color: '#C28562', textDecoration: 'none' }}> info@centralbusinesshub.in</a>.
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    7. Third-Party Links
                  </h2>
                  <p style={{ marginBottom: '20px' }}>
                    Our site may contain links to external websites. We are not responsible for their content or privacy practices. 
                    Please review their privacy policies before submitting any data.
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    8. Children's Privacy
                  </h2>
                  <p style={{ marginBottom: '20px' }}>
                    Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children.
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    9. Changes to This Policy
                  </h2>
                  <p style={{ marginBottom: '20px' }}>
                    We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated effective date.
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ 
                    fontSize: '1.8rem', 
                    fontWeight: '600', 
                    marginBottom: '20px',
                    color: '#34495e',
                    borderBottom: '2px solid #C28562',
                    paddingBottom: '10px'
                  }}>
                    10. Contact Us
                  </h2>
                  <p style={{ marginBottom: '20px' }}>
                    If you have any questions or concerns about this Privacy Policy, contact us at:
                  </p>
                  <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: '25px', 
                    borderRadius: '8px',
                    border: '1px solid #e9ecef'
                  }}>
                    <p style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                      <strong>📧 Email:</strong> 
                      <a href="mailto:info@centralbusinesshub.in" style={{ color: '#C28562', textDecoration: 'none' }}> info@centralbusinesshub.in</a>
                    </p>
                    <p style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                      <strong>📍 Address:</strong> Central Business Hub, Opp. Rajhans Ornate, Parle Point, Surat, Gujarat - 395007
                    </p>
                    <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                      <strong>📞 Phone:</strong> 
                      <a href="tel:8988864888" style={{ color: '#C28562', textDecoration: 'none' }}> 89888 64888</a>
                    </p>
                  </div>
                </section>

                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '50px', 
                  padding: '20px',
                  backgroundColor: '#f1f2f6',
                  borderRadius: '8px'
                }}>
                  <p style={{ marginBottom: '0', fontSize: '0.95rem', color: '#666' }}>
                    This Privacy Policy was last updated on {new Date().toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;